const GRAPH_FINGERPRINT_OFFSET = 2166136261;
const GRAPH_FINGERPRINT_PRIME = 16777619;

export function updateGraphFingerprintHash(seed: number, value: string) {
  let hash = seed;
  for (let i = 0; i < value.length; i += 1) {
    hash ^= value.charCodeAt(i);
    hash = Math.imul(hash, GRAPH_FINGERPRINT_PRIME);
  }
  return hash >>> 0;
}

const NODE_POSITION_OVERLAP_THRESHOLD = 0.5;

export function shouldPreserveNodePositions({
  currentNodeIds,
  nextNodeIds,
}: {
  currentNodeIds: Set<string>;
  nextNodeIds: readonly string[];
}): boolean {
  if (currentNodeIds.size === 0 || nextNodeIds.length === 0) {
    return false;
  }
  const overlapCount = nextNodeIds.filter((id) =>
    currentNodeIds.has(id),
  ).length;
  return (
    overlapCount > 0 &&
    overlapCount >=
      Math.ceil(nextNodeIds.length * NODE_POSITION_OVERLAP_THRESHOLD)
  );
}

export function getGraphCollectionFingerprint<TItem>({
  items,
  hashItem,
}: {
  items: readonly TItem[];
  hashItem: (seed: number, item: TItem) => number;
}) {
  let hashSum = 0;
  let hashXor = 0;
  let hashSquareSum = 0;

  for (const item of items) {
    const itemHash = hashItem(GRAPH_FINGERPRINT_OFFSET, item) >>> 0;
    hashSum = (hashSum + itemHash) >>> 0;
    hashXor = (hashXor ^ itemHash) >>> 0;
    hashSquareSum = (hashSquareSum + Math.imul(itemHash, itemHash)) >>> 0;
  }

  return [
    items.length,
    hashSum.toString(36),
    hashXor.toString(36),
    hashSquareSum.toString(36),
  ].join(':');
}
